import { render, staticRenderFns } from "./PasswordChangeEditor.vue?vue&type=template&id=36b805ca&"
import script from "./PasswordChangeEditor.vue?vue&type=script&lang=js&"
export * from "./PasswordChangeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports